import PropTypes from 'prop-types';
// material
import { Box } from '@material-ui/core';
import logoImg from '../logo.png';
import logoDarkModeImg from '../logo-dark-mode.png';

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object,
  darkMode: PropTypes.bool
};

export default function Logo({ sx, darkMode = false }) {
  return (
    <Box sx={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <img
        src={darkMode ? logoDarkModeImg : logoImg}
        alt="logo"
        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
      />
    </Box>
  );
}